<div class="main-content mnt gman table-page">
  <div class="container-fluid">

  <section class="table-page__hero mnt-hero">
    <div class="table-page__copy mnt-hero__copy">
      <span class="material-icons mnt-hero__icono" aria-hidden="true">engineering</span>
      <div class="mnt-hero__textos">
        <h1>Atención de mantenimiento</h1>
        <p>Lo que pidió la gente de tu empresa: tómala, atiéndela y dala por resuelta. Quien la pidió confirma.</p>
      </div>
    </div>
    <div class="table-page__toolbar-actions">
      <a class="app-form-btn app-form-btn--secondary app-form-btn--compact" [routerLink]="['/solicitudes/nueva']"
         [queryParams]="{ ver: 'mantenimiento' }">
        <span class="material-icons" aria-hidden="true">person</span>
        Las mías
      </a>
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
              [disabled]="cargando" (click)="cargar()" title="Actualizar">
        <span class="material-icons" aria-hidden="true">refresh</span>
        Actualizar
      </button>
    </div>
  </section>

  <section class="table-page__card" *ngIf="sinPermiso">
    <div class="table-page__empty">
      <span class="material-icons" aria-hidden="true">lock</span>
      <h3>No tienes acceso a la bandeja</h3>
      <p>{{ sinPermiso }} La da el perfil «Atiende Mantenimiento».</p>
    </div>
  </section>

  <section class="table-page__card" *ngIf="!sinPermiso">

    <!-- ===== Filtros: estatus en pastillas, «solo las mías» y búsqueda ===== -->
    <div class="table-page__toolbar gman-barra">
      <div class="gman-chips" role="tablist" aria-label="Estatus">
        <button type="button" class="gman-chip" *ngFor="let f of FILTROS" role="tab"
                [class.es-activa]="filtro === f.valor" [attr.aria-selected]="filtro === f.valor"
                (click)="elegirFiltro(f)">
          {{ f.texto }}
          <span class="gman-chip__n" *ngIf="conteo(f) as n">{{ n }}</span>
        </button>
      </div>

      <div class="gman-barra__der">
        <button type="button" class="gman-mias" [class.es-activa]="soloMias" [attr.aria-pressed]="soloMias"
                (click)="alternarMias()">
          <span class="material-icons" aria-hidden="true">{{ soloMias ? 'check_box' : 'check_box_outline_blank' }}</span>
          Solo las que atiendo
        </button>
        <mat-form-field appearance="outline" class="table-page__search-field gman-buscar" subscriptSizing="dynamic">
          <span class="material-icons" matPrefix aria-hidden="true">search</span>
          <input matInput type="search" placeholder="Folio, lugar, qué o quién" [(ngModel)]="busca"
                 (ngModelChange)="alBuscar()" name="busca" autocomplete="off" aria-label="Buscar" />
          <button type="button" matSuffix class="gman-limpia" *ngIf="busca" (click)="limpiarBusqueda()" aria-label="Limpiar">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </mat-form-field>
      </div>
    </div>

    <!-- ===== La tabla ===== -->
    <div class="table-page__table-wrap" *ngIf="lista.length; else vacio">
      <table class="table-page__table table-page__table--wide gman-tabla">
        <thead>
          <tr>
            <th>Solicitud</th>
            <th>Asunto</th>
            <th>Pidió</th>
            <th>Urgencia</th>
            <th>Estatus</th>
            <th>Atiende</th>
            <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of lista; trackBy: trackSol" class="is-clickable" (click)="abrir(s)" (keydown.enter)="$event.target === $event.currentTarget ? abrir(s) : null"
              [class.es-urgente]="s.urgencia === 'ALTA' && s.estatus === 'SOLICITADA'">
            <td>
              <div class="gman-sol">
                <span class="mnt-cat" aria-hidden="true"><span class="material-icons">{{ cat(s).icono }}</span></span>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ s.folio }}</strong>
                  <span class="table-page__subtext gman-nowrap" *ngIf="cat(s).texto">{{ cat(s).texto }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack gman-que">
                <span class="table-page__text gman-donde" *ngIf="s.ubicacion">{{ s.ubicacion }}</span>
                <span class="gman-desc" [ngClass]="s.ubicacion ? 'table-page__subtext' : 'table-page__text'">{{ s.descripcion }}</span>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__text gman-nowrap">{{ s.solicitante }}</span>
                <span class="table-page__subtext gman-nowrap">{{ cuando(s.fechaSolicitud) }}</span>
              </div>
            </td>
            <td><span class="mnt-urgencia" [ngClass]="'es-' + (s.urgencia || '').toLowerCase()">{{ urg(s)?.texto }}</span></td>
            <td>
              <div class="table-page__cell-stack gman-est">
                <span class="mnt-estatus" [ngClass]="est(s).clase">
                  <span class="material-icons" aria-hidden="true">{{ est(s).icono }}</span>{{ est(s).texto }}
                </span>
                <span class="table-page__subtext" *ngIf="s.reaperturas">
                  Reabierta {{ s.reaperturas }} {{ s.reaperturas === 1 ? 'vez' : 'veces' }}
                </span>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack" *ngIf="s.responsable; else sinTomar">
                <span class="table-page__text gman-nowrap">{{ s.responsable }}</span>
                <span class="gman-sin gman-sin--baja" *ngIf="huerfana(s) && s.estatus !== 'CERRADA' && s.estatus !== 'CANCELADA'">Ya no atiende</span>
              </div>
              <ng-template #sinTomar><span class="gman-sin">Sin tomar</span></ng-template>
            </td>
            <td class="table-page__actions table-page__actions--multi">
              <div class="table-page__action-group">
                <button type="button" class="gman-tomar" *ngIf="puedeTomar(s)"
                        [disabled]="tomando === s.idSolicitud" (click)="tomar(s, $event)"
                        title="Tomarla: pasa a «En atención»">
                  <span class="material-icons" aria-hidden="true">pan_tool_alt</span>
                  Tomar
                </button>
                <button type="button" class="table-page__action-btn" (click)="$event.stopPropagation(); abrir(s)"
                        title="Ver el detalle" aria-label="Ver el detalle">
                  <span class="material-icons">visibility</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-page__footer" *ngIf="total > porPagina">
      <div class="table-page__meta">Mostrando {{ rangoInicio() }} a {{ rangoFin() }} de {{ total }}</div>
      <nav class="table-page__pager" aria-label="Paginación">
        <button type="button" class="table-page__pager-link" (click)="irPagina(pagina - 1)" [disabled]="pagina <= 1"
                title="Página anterior" aria-label="Página anterior">
          <span class="material-icons">chevron_left</span>
        </button>
        <ng-container *ngFor="let p of paginas()">
          <button *ngIf="p !== null" type="button" class="table-page__pager-page"
                  [class.is-current]="p === pagina" (click)="irPagina(p)">{{ p }}</button>
          <span *ngIf="p === null" class="table-page__pager-ellipsis">…</span>
        </ng-container>
        <button type="button" class="table-page__pager-link" (click)="irPagina(pagina + 1)" [disabled]="pagina >= totalPaginas()"
                title="Página siguiente" aria-label="Página siguiente">
          <span class="material-icons">chevron_right</span>
        </button>
      </nav>
    </div>

    <ng-template #vacio>
      <div class="table-page__empty" *ngIf="!cargando; else consultando">
        <span class="material-icons" aria-hidden="true">{{ filtro === 'ABIERTAS' && !busca ? 'celebration' : 'search_off' }}</span>
        <h3>{{ filtro === 'ABIERTAS' && !busca ? 'Nada pendiente' : 'Sin resultados' }}</h3>
        <p>{{ filtro === 'ABIERTAS' && !busca ? 'No hay solicitudes abiertas' + (soloMias ? ' tuyas' : '') + '.' : 'Prueba con otro estatus u otra búsqueda.' }}</p>
      </div>
    </ng-template>
    <ng-template #consultando>
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <p>Consultando…</p>
      </div>
    </ng-template>
  </section>
  </div>
</div>
